// import React, { useState, useEffect, useRef } from "react";
// import { useHistory } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSync, faUser, faEnvelope, faPhone, faCity, faMapMarkerAlt, faGlobe, faList, faCalendar, faShieldAlt, faClipboardList } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
// import { API_URL } from "../../apiConfig";
// import axios from "axios";
// import LoadingComman from "../Loading/LoadingCommon";
// import HoaTermsConditions from "../HoaTermsConditions/HoaTermsConditions";
// import { useDispatch, useSelector } from "react-redux";
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';

// const HoaChoosePlan = ({ planIds, closeModal }) => {
//     const [countryData, setCountryData] = useState([]);
//     const [stateData, setStateData] = useState([]);
//     const [loadingComman, setLoadingComman] = useState(false);
//     const [showModal, setShowModal] = useState(false);
//     const [formPlanData, setFormPlanData] = useState({
//         fullName: "",
//         email: "",
//         phoneNumber: "",
//         city: "",
//         stateId: "",
//         countryId: "",
//         zipCode: "",
//         planType: "",
//         planRange: "",
//         planPeriod: "",
//         planId: planIds,
//     });
//     const [selectedCountryId, setSelectedCountryId] = useState("");
//     const [rangeOptions, setRangeOptions] = useState([]);
//     const [planTypes, setPlanTypes] = useState([]);
//     const [planPeriods, setPlanPeriods] = useState([]);
//     const [userInput, setUserInput] = useState("");
//     const [captchaText, setCaptchaText] = useState("");
//     const [isChecked, setIsChecked] = useState(false);
//     const [errors, setErrors] = useState({});
//     const [acceptTerms, setAcceptTerms] = useState(false);
//     const canvasRef = useRef(null);

//     // Generate captcha text
//     const generateCaptcha = () => {
//         const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
//         let result = '';
//         for (let i = 0; i < 6; i++) {
//             result += characters.charAt(Math.floor(Math.random() * characters.length));
//         }
//         return result;
//     };

//     // Draw captcha on canvas
//     const drawCaptcha = (text) => {
//         const canvas = canvasRef.current;
//         if (!canvas) return;

//         const ctx = canvas.getContext('2d');
//         canvas.width = 200;
//         canvas.height = 60;

//         // Gradient background
//         const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
//         gradient.addColorStop(0, '#f8fafc');
//         gradient.addColorStop(1, '#e2e8f0');
//         ctx.fillStyle = gradient;
//         ctx.fillRect(0, 0, canvas.width, canvas.height);

//         // Noise lines
//         for (let i = 0; i < 3; i++) {
//             ctx.strokeStyle = `rgba(59, 130, 246, ${Math.random() * 0.2 + 0.1})`;
//             ctx.lineWidth = Math.random() * 1.5 + 0.5;
//             ctx.beginPath();
//             ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
//             ctx.bezierCurveTo(
//                 Math.random() * canvas.width, Math.random() * canvas.height,
//                 Math.random() * canvas.width, Math.random() * canvas.height,
//                 Math.random() * canvas.width, Math.random() * canvas.height
//             );
//             ctx.stroke();
//         }

//         // Dots
//         for (let i = 0; i < 20; i++) {
//             ctx.fillStyle = `rgba(59, 130, 246, ${Math.random() * 0.3 + 0.1})`;
//             ctx.beginPath();
//             ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 1.5 + 0.5, 0, 2 * Math.PI);
//             ctx.fill();
//         }

//         // Draw text
//         ctx.font = 'bold 26px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
//         ctx.textAlign = 'center';
//         ctx.textBaseline = 'middle';

//         const textWidth = canvas.width / text.length;
//         for (let i = 0; i < text.length; i++) {
//             const char = text[i];
//             const x = textWidth * i + textWidth / 2;
//             const y = canvas.height / 2 + (Math.random() - 0.5) * 8;

//             // Gradient color for each character
//             const charGradient = ctx.createLinearGradient(x - 10, y - 10, x + 10, y + 10);
//             charGradient.addColorStop(0, '#1e40af');
//             charGradient.addColorStop(1, '#3b82f6');
//             ctx.fillStyle = charGradient;

//             // Text shadow
//             ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
//             ctx.shadowBlur = 2;
//             ctx.shadowOffsetX = 1;
//             ctx.shadowOffsetY = 1;

//             ctx.save();
//             ctx.translate(x, y);
//             ctx.rotate((Math.random() - 0.5) * 0.3);
//             ctx.fillText(char, 0, 0);
//             ctx.restore();
//         }

//         // Reset shadow
//         ctx.shadowColor = 'transparent';
//         ctx.shadowBlur = 0;
//         ctx.shadowOffsetX = 0;
//         ctx.shadowOffsetY = 0;

//         // Border
//         ctx.strokeStyle = '#cbd5e1';
//         ctx.lineWidth = 1;
//         ctx.strokeRect(0, 0, canvas.width, canvas.height);
//     };

//     // Initialize captcha
//     useEffect(() => {
//         const newCaptcha = generateCaptcha();
//         setCaptchaText(newCaptcha);
//     }, []);

//     // Draw captcha when text changes
//     useEffect(() => {
//         if (captchaText) {
//             drawCaptcha(captchaText);
//         }
//     }, [captchaText]);

//     useEffect(() => {
//         axios.get(`${API_URL}/public/country/getAll`)
//             .then((response) => setCountryData(response.data))
//             .catch((error) => console.error("Error fetching countries:", error));
//         axios.get(`${API_URL}/public/state/getAll`)
//             .then((response) => setStateData(response.data))
//             .catch((error) => console.error("Error fetching states:", error));
//         axios.get(`${API_URL}/public/plan-range/all`)
//             .then((response) => setRangeOptions(response.data?.map(({ id, planRange }) => ({ id, range: planRange }))))
//             .catch((error) => console.error("Error fetching range options:", error));
//         axios.get(`${API_URL}/public/plan-type/all`)
//             .then((response) => setPlanTypes(response.data?.map(({ id, planType }) => ({ id, type: planType }))))
//             .catch((error) => console.error("Error fetching plan types:", error));
//         axios.get(`${API_URL}/public/plan-period/all`)
//             .then((response) => setPlanPeriods(response.data?.map(({ id, planPeriod }) => ({ id, period: planPeriod }))))
//             .catch((error) => console.error("Error fetching plan periods:", error));
//     }, []);

//     useEffect(() => {
//         // Pre-fill plan details if available
//         const fetchData = async () => {
//             try {
//                 const planDetailsResponse = await axios.get(`${API_URL}/public/plan/getOne/${planIds}`);
//                 const planDetailsData = planDetailsResponse.data;
//                 setFormPlanData((prev) => ({
//                     ...prev,
//                     planType: planDetailsData?.planType?.planType || "",
//                     planRange: planDetailsData?.planRange?.planRange || "",
//                     planPeriod: planDetailsData?.planPeriod?.planPeriod || "",
//                 }));
//             } catch (error) {
//                 // ignore if not found
//             }
//         };
//         if (planIds) fetchData();
//     }, [planIds]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormPlanData((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//         if (errors[name]) {
//             setErrors((prev) => ({ ...prev, [name]: "" }));
//         }
//     };

//     const handleCountryChange = (e) => {
//         const selectedCountryId = parseInt(e.target.value, 10);
//         setSelectedCountryId(selectedCountryId);
//         setFormPlanData((prev) => ({
//             ...prev,
//             countryId: selectedCountryId,
//             stateId: "",
//         }));
//         if (errors.countryId) setErrors((prev) => ({ ...prev, countryId: "" }));
//     };

//     const handleStateChange = (e) => {
//         const selectedStateId = parseInt(e.target.value, 10);
//         setFormPlanData((prev) => ({
//             ...prev,
//             stateId: selectedStateId,
//         }));
//         if (errors.stateId) setErrors((prev) => ({ ...prev, stateId: "" }));
//     };

//     const handlePhoneNumberChange = (value) => {
//         setFormPlanData((prev) => ({
//             ...prev,
//             phoneNumber: value,
//         }));
//         if (errors.phoneNumber) setErrors((prev) => ({ ...prev, phoneNumber: "" }));
//     };

//     const handleInputChange = (event) => {
//         setUserInput(event.target.value);
//         if (errors.captcha) setErrors((prev) => ({ ...prev, captcha: "" }));
//     };

//     const handleCheckboxChange = () => {
//         setAcceptTerms(!acceptTerms);
//         if (errors.acceptTerms) setErrors((prev) => ({ ...prev, acceptTerms: "" }));
//     };

//     const refreshCaptcha = () => {
//         const newCaptcha = generateCaptcha();
//         setCaptchaText(newCaptcha);
//         setUserInput("");
//         setErrors((prev) => ({ ...prev, captcha: "" }));
//     };

//     const resetForm = () => {
//         setFormPlanData({
//             fullName: "",
//             email: "",
//             phoneNumber: "",
//             city: "",
//             stateId: "",
//             countryId: "",
//             zipCode: "",
//             planType: "",
//             planRange: "",
//             planPeriod: "",
//             planId: planIds,
//         });
//         setSelectedCountryId("");
//         setUserInput("");
//         setAcceptTerms(false);
//         setErrors({});
//         refreshCaptcha();
//     };

//     const validateForm = () => {
//         let isValid = true;
//         const newErrors = {};

//         if (!formPlanData.fullName.trim()) {
//             newErrors.fullName = "Full Name is required";
//             isValid = false;
//         }
//         if (!/\S+@\S+\.\S+/.test(formPlanData.email)) {
//             newErrors.email = "Invalid email address";
//             isValid = false;
//         }
//         if (!formPlanData.phoneNumber.trim() || formPlanData.phoneNumber.length < 10) {
//             newErrors.phoneNumber = "Phone Number must be at least 10 digits";
//             isValid = false;
//         }
//         if (!formPlanData.city.trim()) {
//             newErrors.city = "City is required";
//             isValid = false;
//         }
//         if (!formPlanData.zipCode.trim()) {
//             newErrors.zipCode = "Zip Code is required";
//             isValid = false;
//         }
//         if (!formPlanData.countryId) {
//             newErrors.countryId = "Country is required";
//             isValid = false;
//         }
//         if (!formPlanData.stateId) {
//             newErrors.stateId = "State is required";
//             isValid = false;
//         }
//         if (!formPlanData.planRange.trim()) {
//             newErrors.planRange = "Plan Range is required";
//             isValid = false;
//         }
//         if (!formPlanData.planType.trim()) {
//             newErrors.planType = "Plan Type is required";
//             isValid = false;
//         }
//         if (!formPlanData.planPeriod.trim()) {
//             newErrors.planPeriod = "Plan Period is required";
//             isValid = false;
//         }
//         if (!userInput.trim()) {
//             newErrors.captcha = "Please enter the captcha";
//             isValid = false;
//         } else if (userInput.toLowerCase() !== captchaText.toLowerCase()) {
//             newErrors.captcha = "Captcha is incorrect. Please try again.";
//             isValid = false;
//         }
//         if (!acceptTerms) {
//             newErrors.acceptTerms = "You must accept the Terms & Conditions";
//             isValid = false;
//         }
//         setErrors(newErrors);
//         return isValid;
//     };

//     const handleSubmitForm = async (e) => {
//         e.preventDefault();
//         setLoadingComman(true);
//         if (validateForm()) {
//             try {
//                 const formData = {
//                     city: formPlanData.city,
//                     contactId: 0,
//                     countryId: parseInt(formPlanData.countryId),
//                     createdDate: new Date().toISOString(),
//                     description: "",
//                     email: formPlanData.email,
//                     followUp: true,
//                     name: formPlanData.fullName,
//                     phoneNumber: formPlanData.phoneNumber,
//                     stateId: parseInt(formPlanData.stateId),
//                     termsAccepted: acceptTerms,
//                     zipCode: formPlanData.zipCode,
//                     planType: formPlanData.planType,
//                     planPeriod: formPlanData.planPeriod,
//                     planRange: formPlanData.planRange,
//                     planId: planIds,
//                 };
//                 await axios.post(`${API_URL}/public/contacts/add`, formData);
//                 alert("Form submitted successfully!");
//                 resetForm();
//             } catch (error) {
//                 alert("There was an error submitting your form. Please try again.");
//             }
//         }
//         setLoadingComman(false);
//     };

//     const toggleModal = () => setShowModal(!showModal);
//     // Updated HoaChoosePlan component with better modal integration
//     // Replace the return statement in your HoaChoosePlan.js file

//     return (
//         <>
//             {loadingComman && <LoadingComman />}
//             {!loadingComman && (
//                 <div className="w-full h-full">
//                     <div className="w-full h-full">
//                         {/* Form Section - More compact layout */}
//                         <div className="px-4 sm:px-6 lg:px-8 pt-6 pb-4">
//                             <form onSubmit={handleSubmitForm} className="space-y-4">
//                                 {/* Personal Information Section */}
//                                 <div className="bg-white/5 rounded-xl p-4 backdrop-blur-sm border border-white/10">
//                                     <div className="flex items-center justify-between mb-3">
//                                         <div className="flex items-center gap-2">
//                                             <FontAwesomeIcon icon={faUser} className="w-4 h-4 text-blue-200" />
//                                             <h3 className="text-base font-semibold text-white">Personal Information</h3>
//                                         </div>
//                                         <div className="flex items-center gap-2 text-xs text-blue-200">
//                                             <span className="w-1.5 h-1.5 bg-red-400 rounded-full animate-pulse"></span>
//                                             Required fields (*)
//                                         </div>
//                                     </div>
//                                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
//                                         <div>
//                                             <label htmlFor="fullName" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 Full Name *
//                                             </label>
//                                             <input
//                                                 type="text"
//                                                 id="fullName"
//                                                 name="fullName"
//                                                 value={formPlanData.fullName}
//                                                 onChange={handleChange}
//                                                 autoComplete="name"
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-sm"
//                                                 placeholder="Enter your full name"
//                                                 maxLength={50}
//                                             />
//                                             {errors.fullName && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.fullName}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="email" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 <FontAwesomeIcon icon={faEnvelope} className="w-3 h-3 mr-2" />
//                                                 Email Address *
//                                             </label>
//                                             <input
//                                                 type="email"
//                                                 id="email"
//                                                 name="email"
//                                                 value={formPlanData.email}
//                                                 onChange={handleChange}
//                                                 autoComplete="email"
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-sm"
//                                                 placeholder="Enter your email address"
//                                                 maxLength={100}
//                                             />
//                                             {errors.email && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.email}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="phoneNumber" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 <FontAwesomeIcon icon={faPhone} className="w-3 h-3 mr-2" />
//                                                 Phone Number *
//                                             </label>
//                                             <PhoneInput
//                                                 placeholder="Enter phone number"
//                                                 value={formPlanData.phoneNumber}
//                                                 onChange={handlePhoneNumberChange}
//                                                 defaultCountry="US"
//                                                 containerClass="w-full"
//                                                 inputClass="phone-input-custom"
//                                                 country={'us'}
//                                                 inputStyle={{
//                                                     width: '100%',
//                                                     height: '36px',
//                                                     fontSize: '14px',
//                                                     borderRadius: '8px',
//                                                     border: '1px solid #d1d5db',
//                                                     outline: 'none',
//                                                     backgroundColor: 'white',
//                                                     color: '#111827',
//                                                     paddingLeft: '60px'
//                                                 }}
//                                                 buttonStyle={{
//                                                     borderRadius: '8px 0 0 8px',
//                                                     border: '1px solid #d1d5db',
//                                                     backgroundColor: 'white'
//                                                 }}
//                                             />
//                                             {errors.phoneNumber && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.phoneNumber}
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Address Information Section */}
//                                 <div className="bg-white/5 rounded-xl p-4 backdrop-blur-sm border border-white/10">
//                                     <div className="flex items-center gap-2 mb-3">
//                                         <FontAwesomeIcon icon={faMapMarkerAlt} className="w-4 h-4 text-blue-200" />
//                                         <h3 className="text-base font-semibold text-white">Address Information</h3>
//                                     </div>
//                                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
//                                         <div>
//                                             <label htmlFor="city" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 <FontAwesomeIcon icon={faCity} className="w-3 h-3 mr-2" />
//                                                 City *
//                                             </label>
//                                             <input
//                                                 type="text"
//                                                 id="city"
//                                                 name="city"
//                                                 value={formPlanData.city}
//                                                 onChange={(e) => {
//                                                     const inputValue = e.target.value;
//                                                     const onlyLetters = inputValue.replace(/[^A-Za-z\s]/g, "");
//                                                     handleChange({
//                                                         target: { name: "city", value: onlyLetters },
//                                                     });
//                                                 }}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-sm"
//                                                 placeholder="Enter your city"
//                                                 maxLength={50}
//                                             />
//                                             {errors.city && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.city}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="zipCode" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 Zip Code *
//                                             </label>
//                                             <input
//                                                 type="text"
//                                                 id="zipCode"
//                                                 name="zipCode"
//                                                 value={formPlanData.zipCode}
//                                                 onChange={handleChange}
//                                                 autoComplete="postal-code"
//                                                 maxLength={6}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-sm"
//                                                 placeholder="Enter zip code"
//                                             />
//                                             {errors.zipCode && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.zipCode}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="countryId" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 <FontAwesomeIcon icon={faGlobe} className="w-3 h-3 mr-2" />
//                                                 Country *
//                                             </label>
//                                             <select
//                                                 id="countryId"
//                                                 name="countryId"
//                                                 value={formPlanData.countryId}
//                                                 onChange={handleCountryChange}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none text-sm"
//                                             >
//                                                 <option value="">Select Country</option>
//                                                 {countryData?.map(country => (
//                                                     <option key={country.countryid} value={country.countryid}>{country.countryname}</option>
//                                                 ))}
//                                             </select>
//                                             {errors.countryId && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.countryId}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="stateId" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 State *
//                                             </label>
//                                             <select
//                                                 id="stateId"
//                                                 name="stateId"
//                                                 value={formPlanData.stateId}
//                                                 onChange={handleStateChange}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none text-sm"
//                                                 disabled={!formPlanData.countryId}
//                                             >
//                                                 <option value="">Select State</option>
//                                                 {stateData
//                                                     .filter(state => state.countryid === Number(formPlanData.countryId))
//                                                     .map(state => (
//                                                         <option key={state.stateid} value={state.stateid}>{state.statename}</option>
//                                                     ))}
//                                             </select>
//                                             {errors.stateId && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.stateId}
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Plan Selection Section */}
//                                 <div className="bg-white/5 rounded-xl p-4 backdrop-blur-sm border border-white/10">
//                                     <div className="flex items-center gap-2 mb-3">
//                                         <FontAwesomeIcon icon={faList} className="w-4 h-4 text-blue-200" />
//                                         <h3 className="text-base font-semibold text-white">Plan Configuration</h3>
//                                     </div>
//                                     <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
//                                         <div>
//                                             <label htmlFor="planRange" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 Plan Range *
//                                             </label>
//                                             <select
//                                                 id="planRange"
//                                                 name="planRange"
//                                                 value={formPlanData.planRange}
//                                                 onChange={handleChange}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none text-sm"
//                                             >
//                                                 <option value="">Select Range</option>
//                                                 {rangeOptions.map((range) => (
//                                                     <option key={range.id} value={range.range}>{range.range}</option>
//                                                 ))}
//                                             </select>
//                                             {errors.planRange && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.planRange}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="planPeriod" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 <FontAwesomeIcon icon={faCalendar} className="w-3 h-3 mr-2" />
//                                                 Plan Period *
//                                             </label>
//                                             <select
//                                                 id="planPeriod"
//                                                 name="planPeriod"
//                                                 value={formPlanData.planPeriod}
//                                                 onChange={handleChange}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none text-sm"
//                                             >
//                                                 <option value="">Select Plan Period</option>
//                                                 {planPeriods.map((period) => (
//                                                     <option key={period.id} value={period.period}>{period.period}</option>
//                                                 ))}
//                                             </select>
//                                             {errors.planPeriod && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.planPeriod}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         <div>
//                                             <label htmlFor="planType" className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 Plan Type *
//                                             </label>
//                                             <select
//                                                 id="planType"
//                                                 name="planType"
//                                                 value={formPlanData.planType}
//                                                 onChange={handleChange}
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none text-sm"
//                                             >
//                                                 <option value="">Select Plan Type</option>
//                                                 {planTypes.map((type) => (
//                                                     <option key={type.id} value={type.type}>{type.type}</option>
//                                                 ))}
//                                             </select>
//                                             {errors.planType && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.planType}
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Security & Terms Section */}
//                                 <div className="bg-white/5 rounded-xl p-4 backdrop-blur-sm border border-white/10">
//                                     <div className="flex items-center gap-2 mb-3">
//                                         <FontAwesomeIcon icon={faShieldAlt} className="w-4 h-4 text-blue-200" />
//                                         <h3 className="text-base font-semibold text-white">Security & Agreement</h3>
//                                     </div>

//                                     {/* 2x2 Grid Layout */}
//                                     <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                                         {/* Row 1 Left: Captcha */}
//                                         <div className="flex flex-col">
//                                             <label className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 Security Verification *
//                                             </label>
//                                             <div className="flex items-center gap-2">
//                                                 <div className="bg-white rounded-lg p-1.5 shadow-lg border border-gray-200">
//                                                     <canvas
//                                                         ref={canvasRef}
//                                                         className="rounded w-full"
//                                                         style={{ display: 'block', width: 150, height: 'auto', aspectRatio: '4/1' }}
//                                                     />
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     onClick={refreshCaptcha}
//                                                     className="flex-shrink-0 p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40 group"
//                                                     title="Generate new captcha"
//                                                 >
//                                                     <FontAwesomeIcon
//                                                         icon={faSync}
//                                                         className="w-3.5 h-3.5 text-white group-hover:rotate-180 transition-transform duration-300"
//                                                     />
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         {/* Row 1 Right: Enter Text */}
//                                         <div className="flex flex-col">
//                                             <label className="block mb-1.5 text-sm font-medium text-blue-100">
//                                                 Enter Characters *
//                                             </label>
//                                             <input
//                                                 type="text"
//                                                 value={userInput}
//                                                 onChange={handleInputChange}
//                                                 placeholder="Enter characters from image"
//                                                 className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-center font-mono tracking-wider text-sm"
//                                                 maxLength={6}
//                                             />
//                                             {errors.captcha && (
//                                                 <p className="mt-1 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.captcha}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         {/* Row 2 Left: Terms & Conditions */}
//                                         <div className="flex flex-col justify-center">
//                                             <div className="flex items-start gap-2">
//                                                 <div className="flex items-center h-5 mt-0.5">
//                                                     <input
//                                                         type="checkbox"
//                                                         id="acceptTerms"
//                                                         checked={acceptTerms}
//                                                         onChange={handleCheckboxChange}
//                                                         className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-all duration-200"
//                                                     />
//                                                 </div>
//                                                 <label htmlFor="acceptTerms" className="text-sm text-blue-100 leading-relaxed cursor-pointer">
//                                                     I agree to the{' '}
//                                                     <Link
//                                                         to="#"
//                                                         onClick={toggleModal}
//                                                         className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
//                                                     >
//                                                         Terms & Conditions
//                                                     </Link>
//                                                     {' '}and understand how my information will be used.
//                                                 </label>
//                                             </div>
//                                             {errors.acceptTerms && (
//                                                 <p className="mt-1.5 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20">
//                                                     {errors.acceptTerms}
//                                                 </p>
//                                             )}
//                                         </div>

//                                         {/* Row 2 Right: Action Buttons */}
//                                         <div className="flex flex-col justify-center">
//                                             <div className="flex flex-col sm:flex-row gap-2.5">
//                                                 <button
//                                                     type="button"
//                                                     onClick={resetForm}
//                                                     className="flex-1 px-4 py-2 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40 hover:scale-105 transform text-sm"
//                                                 >
//                                                     Reset Form
//                                                 </button>
//                                                 <button
//                                                     type="submit"
//                                                     className="flex-1 px-4 py-2 bg-white hover:bg-gray-100 text-blue-800 font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform border border-white text-sm"
//                                                 >
//                                                     Complete Registration
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>

//                         {/* Enhanced Modal for Terms */}
//                         {showModal && (
//                             <div className="fixed z-[10000] inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
//                                 <div className="relative bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
//                                     <div className="flex items-center justify-between p-4 border-b border-white/10">
//                                         <h3 className="text-lg font-bold text-white">Terms & Conditions</h3>
//                                         <button
//                                             onClick={toggleModal}
//                                             className="p-2 hover:bg-white/10 rounded-lg transition-colors duration-200"
//                                         >
//                                             <span className="text-xl text-white hover:text-gray-300">&times;</span>
//                                         </button>
//                                     </div>
//                                     <div className="p-4 overflow-y-auto max-h-[calc(90vh-80px)]">
//                                         <HoaTermsConditions closeModal={toggleModal} />
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </>
//     );

//     //return (
//     //    <>
//     //        {loadingComman && <LoadingComman />}
//     //        {!loadingComman && (
//     //            <div className="py-8 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen px-4">
//     //                <div className="max-w-6xl mx-auto">
//     //                    <div className="bg-gradient-to-br from-blue-800 to-blue-900 shadow-2xl rounded-2xl overflow-hidden">
//     //                        {/* Header Section */}
//     //                        <div className="px-6 sm:px-8 lg:px-12 py-8 border-b border-blue-700/30 relative">
//     //                            {/* Close Button */}
//     //                            <button
//     //                                onClick={() => closeModal && closeModal(false)}
//     //                                className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 rounded-xl transition-colors duration-200 z-10"
//     //                                title="Close"
//     //                            >
//     //                                <span className="text-2xl text-white hover:text-gray-300">×</span>
//     //                            </button>

//     //                            <div className="flex items-center gap-4 mb-6">
//     //                                <div className="p-3 bg-white/10 rounded-xl backdrop-blur-sm">
//     //                                    <FontAwesomeIcon icon={faClipboardList} className="w-6 h-6 text-white" />
//     //                                </div>
//     //                                <div>
//     //                                    <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Plan Registration</h1>
//     //                                    <p className="text-blue-100 text-lg">Complete your HOA plan setup with your details</p>
//     //                                </div>
//     //                            </div>
//     //                            <div className="flex items-center gap-2 text-sm text-blue-200">
//     //                                <span className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></span>
//     //                                Required fields are marked with an asterisk (*)
//     //                            </div>
//     //                        </div>

//     //                        {/* Form Section */}
//     //                        <div className="px-6 sm:px-8 lg:px-12 py-8">
//     //                            <form onSubmit={handleSubmitForm} className="space-y-8">
//     //                                {/* Personal Information Section */}
//     //                                <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
//     //                                    <div className="flex items-center gap-3 mb-6">
//     //                                        <FontAwesomeIcon icon={faUser} className="w-5 h-5 text-blue-200" />
//     //                                        <h3 className="text-xl font-semibold text-white">Personal Information</h3>
//     //                                    </div>
//     //                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//     //                                        <div>
//     //                                            <label htmlFor="fullName" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                Full Name *
//     //                                            </label>
//     //                                            <input
//     //                                                type="text"
//     //                                                id="fullName"
//     //                                                name="fullName"
//     //                                                value={formPlanData.fullName}
//     //                                                onChange={handleChange}
//     //                                                autoComplete="name"
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
//     //                                                placeholder="Enter your full name"
//     //                                                maxLength={50}
//     //                                            />
//     //                                            {errors.fullName && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.fullName}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div>
//     //                                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                <FontAwesomeIcon icon={faEnvelope} className="w-4 h-4 mr-2" />
//     //                                                Email Address *
//     //                                            </label>
//     //                                            <input
//     //                                                type="email"
//     //                                                id="email"
//     //                                                name="email"
//     //                                                value={formPlanData.email}
//     //                                                onChange={handleChange}
//     //                                                autoComplete="email"
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
//     //                                                placeholder="Enter your email address"
//     //                                                maxLength={100}
//     //                                            />
//     //                                            {errors.email && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.email}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div className="md:col-span-2">
//     //                                            <label htmlFor="phoneNumber" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                <FontAwesomeIcon icon={faPhone} className="w-4 h-4 mr-2" />
//     //                                                Phone Number *
//     //                                            </label>
//     //                                            <PhoneInput
//     //                                                placeholder="Enter phone number"
//     //                                                value={formPlanData.phoneNumber}
//     //                                                onChange={handlePhoneNumberChange}
//     //                                                defaultCountry="US"
//     //                                                containerClass="w-full max-w-md"
//     //                                                inputClass="phone-input-custom"
//     //                                                country={'us'}
//     //                                                inputStyle={{
//     //                                                    width: '100%',
//     //                                                    height: '48px',
//     //                                                    fontSize: '16px',
//     //                                                    borderRadius: '12px',
//     //                                                    border: '1px solid #d1d5db',
//     //                                                    outline: 'none',
//     //                                                    backgroundColor: 'white',
//     //                                                    color: '#111827',
//     //                                                    paddingLeft: '60px'
//     //                                                }}
//     //                                                buttonStyle={{
//     //                                                    borderRadius: '12px 0 0 12px',
//     //                                                    border: '1px solid #d1d5db',
//     //                                                    backgroundColor: 'white'
//     //                                                }}
//     //                                            />
//     //                                            {errors.phoneNumber && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.phoneNumber}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>
//     //                                    </div>
//     //                                </div>

//     //                                {/* Address Information Section */}
//     //                                <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
//     //                                    <div className="flex items-center gap-3 mb-6">
//     //                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="w-5 h-5 text-blue-200" />
//     //                                        <h3 className="text-xl font-semibold text-white">Address Information</h3>
//     //                                    </div>
//     //                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//     //                                        <div>
//     //                                            <label htmlFor="city" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                <FontAwesomeIcon icon={faCity} className="w-4 h-4 mr-2" />
//     //                                                City *
//     //                                            </label>
//     //                                            <input
//     //                                                type="text"
//     //                                                id="city"
//     //                                                name="city"
//     //                                                value={formPlanData.city}
//     //                                                onChange={(e) => {
//     //                                                    const inputValue = e.target.value;
//     //                                                    const onlyLetters = inputValue.replace(/[^A-Za-z\s]/g, "");
//     //                                                    handleChange({
//     //                                                        target: { name: "city", value: onlyLetters },
//     //                                                    });
//     //                                                }}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
//     //                                                placeholder="Enter your city"
//     //                                                maxLength={50}
//     //                                            />
//     //                                            {errors.city && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.city}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div>
//     //                                            <label htmlFor="zipCode" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                Zip Code *
//     //                                            </label>
//     //                                            <input
//     //                                                type="text"
//     //                                                id="zipCode"
//     //                                                name="zipCode"
//     //                                                value={formPlanData.zipCode}
//     //                                                onChange={handleChange}
//     //                                                autoComplete="postal-code"
//     //                                                maxLength={6}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
//     //                                                placeholder="Enter zip code"
//     //                                            />
//     //                                            {errors.zipCode && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.zipCode}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div>
//     //                                            <label htmlFor="countryId" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                <FontAwesomeIcon icon={faGlobe} className="w-4 h-4 mr-2" />
//     //                                                Country *
//     //                                            </label>
//     //                                            <select
//     //                                                id="countryId"
//     //                                                name="countryId"
//     //                                                value={formPlanData.countryId}
//     //                                                onChange={handleCountryChange}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
//     //                                            >
//     //                                                <option value="">Select Country</option>
//     //                                                {countryData?.map(country => (
//     //                                                    <option key={country.countryid} value={country.countryid}>{country.countryname}</option>
//     //                                                ))}
//     //                                            </select>
//     //                                            {errors.countryId && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.countryId}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div className="md:col-span-2 lg:col-span-1">
//     //                                            <label htmlFor="stateId" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                State *
//     //                                            </label>
//     //                                            <select
//     //                                                id="stateId"
//     //                                                name="stateId"
//     //                                                value={formPlanData.stateId}
//     //                                                onChange={handleStateChange}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
//     //                                                disabled={!formPlanData.countryId}
//     //                                            >
//     //                                                <option value="">Select State</option>
//     //                                                {stateData
//     //                                                    .filter(state => state.countryid === Number(formPlanData.countryId))
//     //                                                    .map(state => (
//     //                                                        <option key={state.stateid} value={state.stateid}>{state.statename}</option>
//     //                                                    ))}
//     //                                            </select>
//     //                                            {errors.stateId && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.stateId}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>
//     //                                    </div>
//     //                                </div>

//     //                                {/* Plan Selection Section */}
//     //                                <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
//     //                                    <div className="flex items-center gap-3 mb-6">
//     //                                        <FontAwesomeIcon icon={faList} className="w-5 h-5 text-blue-200" />
//     //                                        <h3 className="text-xl font-semibold text-white">Plan Configuration</h3>
//     //                                    </div>
//     //                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//     //                                        <div>
//     //                                            <label htmlFor="planRange" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                Plan Range *
//     //                                            </label>
//     //                                            <select
//     //                                                id="planRange"
//     //                                                name="planRange"
//     //                                                value={formPlanData.planRange}
//     //                                                onChange={handleChange}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
//     //                                            >
//     //                                                <option value="">Select Range</option>
//     //                                                {rangeOptions.map((range) => (
//     //                                                    <option key={range.id} value={range.range}>{range.range}</option>
//     //                                                ))}
//     //                                            </select>
//     //                                            {errors.planRange && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.planRange}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div>
//     //                                            <label htmlFor="planPeriod" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                <FontAwesomeIcon icon={faCalendar} className="w-4 h-4 mr-2" />
//     //                                                Plan Period *
//     //                                            </label>
//     //                                            <select
//     //                                                id="planPeriod"
//     //                                                name="planPeriod"
//     //                                                value={formPlanData.planPeriod}
//     //                                                onChange={handleChange}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
//     //                                            >
//     //                                                <option value="">Select Plan Period</option>
//     //                                                {planPeriods.map((period) => (
//     //                                                    <option key={period.id} value={period.period}>{period.period}</option>
//     //                                                ))}
//     //                                            </select>
//     //                                            {errors.planPeriod && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.planPeriod}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        <div>
//     //                                            <label htmlFor="planType" className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                Plan Type *
//     //                                            </label>
//     //                                            <select
//     //                                                id="planType"
//     //                                                name="planType"
//     //                                                value={formPlanData.planType}
//     //                                                onChange={handleChange}
//     //                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
//     //                                            >
//     //                                                <option value="">Select Plan Type</option>
//     //                                                {planTypes.map((type) => (
//     //                                                    <option key={type.id} value={type.type}>{type.type}</option>
//     //                                                ))}
//     //                                            </select>
//     //                                            {errors.planType && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.planType}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>
//     //                                    </div>
//     //                                </div>

//     //                                {/* Security & Terms Section */}
//     //                                <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
//     //                                    <div className="flex items-center gap-3 mb-6">
//     //                                        <FontAwesomeIcon icon={faShieldAlt} className="w-5 h-5 text-blue-200" />
//     //                                        <h3 className="text-xl font-semibold text-white">Security & Agreement</h3>
//     //                                    </div>

//     //                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
//     //                                        {/* Captcha */}
//     //                                        <div className="flex flex-col h-full">
//     //                                            <label className="block mb-2 text-sm font-medium text-blue-100">
//     //                                                Security Verification *
//     //                                            </label>
//     //                                            <div className="flex items-center gap-3 mb-4">
//     //                                                <div className="flex-1 bg-white rounded-xl p-3 shadow-lg border-2 border-gray-200">
//     //                                                    <canvas
//     //                                                        ref={canvasRef}
//     //                                                        className="rounded-lg w-full h-auto"
//     //                                                        style={{ display: 'block' }}
//     //                                                    />
//     //                                                </div>
//     //                                                <button
//     //                                                    type="button"
//     //                                                    onClick={refreshCaptcha}
//     //                                                    className="flex-shrink-0 p-3 bg-white/10 hover:bg-white/20 rounded-xl transition-all duration-200 border border-white/20 hover:border-white/40 group"
//     //                                                    title="Generate new captcha"
//     //                                                >
//     //                                                    <FontAwesomeIcon
//     //                                                        icon={faSync}
//     //                                                        className="w-5 h-5 text-white group-hover:rotate-180 transition-transform duration-300"
//     //                                                    />
//     //                                                </button>
//     //                                            </div>
//     //                                            <div className="flex-1">
//     //                                                <input
//     //                                                    type="text"
//     //                                                    value={userInput}
//     //                                                    onChange={handleInputChange}
//     //                                                    placeholder="Enter characters above"
//     //                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-center font-mono tracking-wider"
//     //                                                    maxLength={6}
//     //                                                />
//     //                                            </div>
//     //                                            {errors.captcha && (
//     //                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                    {errors.captcha}
//     //                                                </p>
//     //                                            )}
//     //                                        </div>

//     //                                        {/* Terms */}
//     //                                        <div className="flex flex-col h-full justify-center">
//     //                                            <div className="space-y-4">
//     //                                                <div className="flex items-start gap-3">
//     //                                                    <div className="flex items-center h-6">
//     //                                                        <input
//     //                                                            type="checkbox"
//     //                                                            id="acceptTerms"
//     //                                                            checked={acceptTerms}
//     //                                                            onChange={handleCheckboxChange}
//     //                                                            className="w-5 h-5 text-blue-600 bg-white border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-all duration-200"
//     //                                                        />
//     //                                                    </div>
//     //                                                    <label htmlFor="acceptTerms" className="text-sm text-blue-100 leading-relaxed cursor-pointer">
//     //                                                        I agree to the{' '}
//     //                                                        <Link
//     //                                                            to="#"
//     //                                                            onClick={toggleModal}
//     //                                                            className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
//     //                                                        >
//     //                                                            Terms & Conditions
//     //                                                        </Link>
//     //                                                        {' '}and understand how my information will be used.
//     //                                                    </label>
//     //                                                </div>
//     //                                                {errors.acceptTerms && (
//     //                                                    <p className="text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
//     //                                                        {errors.acceptTerms}
//     //                                                    </p>
//     //                                                )}
//     //                                            </div>

//     //                                            {/* Action Buttons */}
//     //                                            <div className="flex flex-col sm:flex-row gap-4 mt-8">
//     //                                                <button
//     //                                                    type="button"
//     //                                                    onClick={resetForm}
//     //                                                    className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl transition-all duration-200 border border-white/20 hover:border-white/40 hover:scale-105 transform"
//     //                                                >
//     //                                                    Reset Form
//     //                                                </button>
//     //                                                <button
//     //                                                    type="submit"
//     //                                                    className="px-8 py-3 bg-white hover:bg-gray-100 text-blue-800 font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform border border-white"
//     //                                                >
//     //                                                    Complete Registration
//     //                                                </button>
//     //                                            </div>
//     //                                        </div>
//     //                                    </div>
//     //                                </div>
//     //                            </form>
//     //                        </div>
//     //                    </div>

//     //                    {/* Enhanced Modal */}
//     //                    {showModal && (
//     //                        <div className="fixed z-[9999] inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
//     //                            <div className="relative bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
//     //                                <div className="flex items-center justify-between p-6 border-b border-white/10">
//     //                                    <h3 className="text-xl font-bold text-white">Terms & Conditions</h3>
//     //                                    <button
//     //                                        onClick={toggleModal}
//     //                                        className="p-2 hover:bg-white/10 rounded-lg transition-colors duration-200"
//     //                                    >
//     //                                        <span className="text-2xl text-white hover:text-gray-300">&times;</span>
//     //                                    </button>
//     //                                </div>
//     //                                <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
//     //                                    <HoaTermsConditions closeModal={toggleModal} />
//     //                                </div>
//     //                            </div>
//     //                        </div>
//     //                    )}
//     //                </div>
//     //            </div>
//     //        )}
//     //    </>
//     //);
// };

// export default HoaChoosePlan;

import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faUser, faEnvelope, faPhone, faCity, faMapMarkerAlt, faGlobe, faList, faCalendar, faShieldAlt, faClipboardList, faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { API_URL } from "../../apiConfig";
import axios from "axios";
import LoadingComman from "../Loading/LoadingCommon";
import HoaTermsConditions from "../HoaTermsConditions/HoaTermsConditions";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const HoaChoosePlan = ({ planIds, closeModal }) => {
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [loadingComman, setLoadingComman] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formPlanData, setFormPlanData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        city: "",
        stateId: "",
        countryId: "",
        zipCode: "",
        planType: "",
        planRange: "",
        planPeriod: "",
        planId: planIds,
    });
    const [selectedCountryId, setSelectedCountryId] = useState("");
    const [rangeOptions, setRangeOptions] = useState([]);
    const [planTypes, setPlanTypes] = useState([]);
    const [planPeriods, setPlanPeriods] = useState([]);
    const [userInput, setUserInput] = useState("");
    const [captchaText, setCaptchaText] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [errors, setErrors] = useState({});
    const [acceptTerms, setAcceptTerms] = useState(false);
    const canvasRef = useRef(null);

    // Generate captcha text
    const generateCaptcha = () => {
        const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
        let result = '';
        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    };

    // Draw captcha on canvas
    const drawCaptcha = (text) => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        canvas.width = 200;
        canvas.height = 60;

        // Gradient background
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#f8fafc');
        gradient.addColorStop(1, '#e2e8f0');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Noise lines
        for (let i = 0; i < 3; i++) {
            ctx.strokeStyle = `rgba(59, 130, 246, ${Math.random() * 0.2 + 0.1})`;
            ctx.lineWidth = Math.random() * 1.5 + 0.5;
            ctx.beginPath();
            ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.bezierCurveTo(
                Math.random() * canvas.width, Math.random() * canvas.height,
                Math.random() * canvas.width, Math.random() * canvas.height,
                Math.random() * canvas.width, Math.random() * canvas.height
            );
            ctx.stroke();
        }

        // Dots
        for (let i = 0; i < 20; i++) {
            ctx.fillStyle = `rgba(59, 130, 246, ${Math.random() * 0.3 + 0.1})`;
            ctx.beginPath();
            ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 1.5 + 0.5, 0, 2 * Math.PI);
            ctx.fill();
        }

        // Draw text
        ctx.font = 'bold 26px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const textWidth = canvas.width / text.length;
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const x = textWidth * i + textWidth / 2;
            const y = canvas.height / 2 + (Math.random() - 0.5) * 8;

            // Gradient color for each character
            const charGradient = ctx.createLinearGradient(x - 10, y - 10, x + 10, y + 10);
            charGradient.addColorStop(0, '#1e40af');
            charGradient.addColorStop(1, '#3b82f6');
            ctx.fillStyle = charGradient;

            // Text shadow
            ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
            ctx.shadowBlur = 2;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;

            ctx.save();
            ctx.translate(x, y);
            ctx.rotate((Math.random() - 0.5) * 0.3);
            ctx.fillText(char, 0, 0);
            ctx.restore();
        }

        // Reset shadow
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;

        // Border
        ctx.strokeStyle = '#cbd5e1';
        ctx.lineWidth = 1;
        ctx.strokeRect(0, 0, canvas.width, canvas.height);
    };

    // Initialize captcha
    useEffect(() => {
        const newCaptcha = generateCaptcha();
        setCaptchaText(newCaptcha);
    }, []);

    // Draw captcha when text changes
    useEffect(() => {
        if (captchaText) {
            drawCaptcha(captchaText);
        }
    }, [captchaText]);

    useEffect(() => {
        axios.get(`${API_URL}/public/country/getAll`)
            .then((response) => setCountryData(response.data))
            .catch((error) => console.error("Error fetching countries:", error));
        axios.get(`${API_URL}/public/state/getAll`)
            .then((response) => setStateData(response.data))
            .catch((error) => console.error("Error fetching states:", error));
        axios.get(`${API_URL}/public/plan-range/all`)
            .then((response) => setRangeOptions(response.data?.map(({ id, planRange }) => ({ id, range: planRange }))))
            .catch((error) => console.error("Error fetching range options:", error));
        axios.get(`${API_URL}/public/plan-type/all`)
            .then((response) => setPlanTypes(response.data?.map(({ id, planType }) => ({ id, type: planType }))))
            .catch((error) => console.error("Error fetching plan types:", error));
        axios.get(`${API_URL}/public/plan-period/all`)
            .then((response) => setPlanPeriods(response.data?.map(({ id, planPeriod }) => ({ id, period: planPeriod }))))
            .catch((error) => console.error("Error fetching plan periods:", error));
    }, []);

    useEffect(() => {
        // Pre-fill plan details if available
        const fetchData = async () => {
            try {
                const planDetailsResponse = await axios.get(`${API_URL}/public/plan/getOne/${planIds}`);
                const planDetailsData = planDetailsResponse.data;
                console.log(planDetailsData)
                setFormPlanData((prev) => ({
                    ...prev,
                    planType: planDetailsData?.planType?.planType || "",
                    planRange: planDetailsData?.planRange?.planRange || "",
                    planPeriod: planDetailsData?.planPeriod?.planPeriod || "",
                }));
            } catch (error) {
                // ignore if not found
            }
        };
        if (planIds) fetchData();
    }, [planIds]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormPlanData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };

    const handleCountryChange = (e) => {
        const selectedCountryId = parseInt(e.target.value, 10);
        setSelectedCountryId(selectedCountryId);
        setFormPlanData((prev) => ({
            ...prev,
            countryId: selectedCountryId,
            stateId: "",
        }));
        if (errors.countryId) setErrors((prev) => ({ ...prev, countryId: "" }));
    };

    const handleStateChange = (e) => {
        const selectedStateId = parseInt(e.target.value, 10);
        setFormPlanData((prev) => ({
            ...prev,
            stateId: selectedStateId,
        }));
        if (errors.stateId) setErrors((prev) => ({ ...prev, stateId: "" }));
    };

    const handlePhoneNumberChange = (value) => {
        setFormPlanData((prev) => ({
            ...prev,
            phoneNumber: value,
        }));
        if (errors.phoneNumber) setErrors((prev) => ({ ...prev, phoneNumber: "" }));
    };

    const handleInputChange = (event) => {
        setUserInput(event.target.value);
        console.log("Captcha Input:", event.target.value);
        if (errors.captcha) setErrors((prev) => ({ ...prev, captcha: "" }));
    };

    const handleCheckboxChange = () => {
        setAcceptTerms(!acceptTerms);
        if (errors.acceptTerms) setErrors((prev) => ({ ...prev, acceptTerms: "" }));
    };

    const refreshCaptcha = () => {
        const newCaptcha = generateCaptcha();
        setCaptchaText(newCaptcha);
        setUserInput("");
        setErrors((prev) => ({ ...prev, captcha: "" }));
    };

    const resetForm = () => {
        setFormPlanData({
            fullName: "",
            email: "",
            phoneNumber: "",
            city: "",
            stateId: "",
            countryId: "",
            zipCode: "",
            planType: "",
            planRange: "",
            planPeriod: "",
            planId: planIds,
        });
        setSelectedCountryId("");
        setUserInput("");
        setAcceptTerms(false);
        setErrors({});
        refreshCaptcha();
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!formPlanData.fullName.trim()) {
            newErrors.fullName = "Full Name is required";
            isValid = false;
        }
        if (!/\S+@\S+\.\S+/.test(formPlanData.email)) {
            newErrors.email = "Invalid email address";
            isValid = false;
        }
        if (!formPlanData.phoneNumber.trim() || formPlanData.phoneNumber.length < 10) {
            newErrors.phoneNumber = "Phone Number must be at least 10 digits";
            isValid = false;
        }
        if (!formPlanData.city.trim()) {
            newErrors.city = "City is required";
            isValid = false;
        }
        if (!formPlanData.zipCode.trim()) {
            newErrors.zipCode = "Zip Code is required";
            isValid = false;
        }
        if (!formPlanData.countryId) {
            newErrors.countryId = "Country is required";
            isValid = false;
        }
        if (!formPlanData.stateId) {
            newErrors.stateId = "State is required";
            isValid = false;
        }
        if (!formPlanData.planRange.trim()) {
            newErrors.planRange = "Plan Range is required";
            isValid = false;
        }
        if (!formPlanData.planType.trim()) {
            newErrors.planType = "Plan Type is required";
            isValid = false;
        }
        if (!formPlanData.planPeriod.trim()) {
            newErrors.planPeriod = "Plan Period is required";
            isValid = false;
        }
        if (!userInput.trim()) {
            newErrors.captcha = "Please enter the captcha";
            isValid = false;
        } else if (userInput.toLowerCase() !== captchaText.toLowerCase()) {
            newErrors.captcha = "Captcha is incorrect. Please try again.";
            isValid = false;
        }
        if (!acceptTerms) {
            newErrors.acceptTerms = "You must accept the Terms & Conditions";
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    };

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        setLoadingComman(true);
        if (validateForm()) {
            try {
                const formData = {
                    city: formPlanData.city,
                    contactId: 0,
                    countryId: parseInt(formPlanData.countryId),
                    createdDate: new Date().toISOString(),
                    description: "",
                    email: formPlanData.email,
                    followUp: true,
                    name: formPlanData.fullName,
                    phoneNumber: formPlanData.phoneNumber,
                    stateId: parseInt(formPlanData.stateId),
                    termsAccepted: acceptTerms,
                    zipCode: formPlanData.zipCode,
                    planType: formPlanData.planType,
                    planPeriod: formPlanData.planPeriod,
                    planRange: formPlanData.planRange,
                    planId: planIds,
                };
                await axios.post(`${API_URL}/public/contacts/add`, formData);
                alert("Form submitted successfully!");
                resetForm();
            } catch (error) {
                alert("There was an error submitting your form. Please try again.");
            }
        }
        setLoadingComman(false);
    };

    const toggleModal = () => setShowModal(!showModal);

    // Common styles for consistency
    const inputStyles = "w-full h-10 px-3 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-sm";
    const labelStyles = "block mb-2 text-sm font-medium text-blue-100";
    const errorStyles = "mt-1.5 text-xs text-red-300 bg-red-500/10 px-2 py-1 rounded border border-red-500/20";
    const sectionStyles = "bg-white/5 rounded-xl p-5 backdrop-blur-sm border border-white/10 space-y-4";
    const sectionHeaderStyles = "flex items-center gap-2 mb-4 pb-2 border-b border-white/10";

    return (
        <>
            {loadingComman && <LoadingComman />}
            {!loadingComman && (
                <div className="w-full h-full min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
                    <div className="w-full h-full">
                        {/* Header */}
                        <div className="px-4 sm:px-6 lg:px-8 pt-6 pb-4">
                            <div className="text-center mb-6">
                                <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                                    <FontAwesomeIcon icon={faClipboardList} className="w-6 h-6 mr-3" />
                                    Choose Your Plan
                                </h1>
                                <p className="text-blue-200 text-sm">Complete the form below to register for your selected plan</p>
                            </div>
                        </div>

                        {/* Form Section */}
                        <div className="px-4 sm:px-6 lg:px-8 pb-8">
                            <form onSubmit={handleSubmitForm} className="max-w-6xl mx-auto space-y-6">
                                {/* Personal Information Section */}
                                <div className={sectionStyles}>
                                    <div className={sectionHeaderStyles}>
                                        <div className="flex items-center gap-2">
                                            <FontAwesomeIcon icon={faUser} className="w-5 h-5 text-blue-200" />
                                            <h3 className="text-lg font-semibold text-white">Personal Information</h3>
                                        </div>
                                        <div className="flex items-center gap-2 text-xs text-blue-200 ml-auto">
                                            <FontAwesomeIcon icon={faAsterisk} className="w-2 h-2 text-red-400" />
                                            <span>Required fields</span>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        <div className="space-y-1">
                                            <label htmlFor="fullName" className={labelStyles}>
                                                Full Name <span className="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="fullName"
                                                name="fullName"
                                                value={formPlanData.fullName}
                                                onChange={handleChange}
                                                autoComplete="name"
                                                className={inputStyles}
                                                placeholder="Enter your full name"
                                                maxLength={50}
                                            />
                                            {errors.fullName && (
                                                <p className={errorStyles}>{errors.fullName}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="email" className={labelStyles}>
                                                <FontAwesomeIcon icon={faEnvelope} className="w-3 h-3 mr-2" />
                                                Email Address <span className="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formPlanData.email}
                                                onChange={handleChange}
                                                autoComplete="email"
                                                className={inputStyles}
                                                placeholder="Enter your email address"
                                                maxLength={100}
                                            />
                                            {errors.email && (
                                                <p className={errorStyles}>{errors.email}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="phoneNumber" className={labelStyles}>
                                                <FontAwesomeIcon icon={faPhone} className="w-3 h-3 mr-2" />
                                                Phone Number <span className="text-red-400">*</span>
                                            </label>
                                            <PhoneInput
                                                placeholder="Enter phone number"
                                                value={formPlanData.phoneNumber}
                                                onChange={handlePhoneNumberChange}
                                                defaultCountry="US"
                                                containerClass="w-full"
                                                inputClass="phone-input-custom"
                                                country={'us'}
                                                inputStyle={{
                                                    width: '100%',
                                                    height: '40px',
                                                    fontSize: '14px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #d1d5db',
                                                    outline: 'none',
                                                    backgroundColor: 'white',
                                                    color: '#111827',
                                                    paddingLeft: '60px'
                                                }}
                                                buttonStyle={{
                                                    borderRadius: '8px 0 0 8px',
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: 'white'
                                                }}
                                            />
                                            {errors.phoneNumber && (
                                                <p className={errorStyles}>{errors.phoneNumber}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Address Information Section */}
                                <div className={sectionStyles}>
                                    <div className={sectionHeaderStyles}>
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="w-5 h-5 text-blue-200" />
                                        <h3 className="text-lg font-semibold text-white">Address Information</h3>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                        <div className="space-y-1">
                                            <label htmlFor="city" className={labelStyles}>
                                                <FontAwesomeIcon icon={faCity} className="w-3 h-3 mr-2" />
                                                City <span className="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="city"
                                                name="city"
                                                value={formPlanData.city}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const onlyLetters = inputValue.replace(/[^A-Za-z\s]/g, "");
                                                    handleChange({
                                                        target: { name: "city", value: onlyLetters },
                                                    });
                                                }}
                                                className={inputStyles}
                                                placeholder="Enter your city"
                                                maxLength={50}
                                            />
                                            {errors.city && (
                                                <p className={errorStyles}>{errors.city}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="zipCode" className={labelStyles}>
                                                Zip Code <span className="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="zipCode"
                                                name="zipCode"
                                                value={formPlanData.zipCode}
                                                onChange={handleChange}
                                                autoComplete="postal-code"
                                                maxLength={6}
                                                className={inputStyles}
                                                placeholder="Enter zip code"
                                            />
                                            {errors.zipCode && (
                                                <p className={errorStyles}>{errors.zipCode}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="countryId" className={labelStyles}>
                                                <FontAwesomeIcon icon={faGlobe} className="w-3 h-3 mr-2" />
                                                Country <span className="text-red-400">*</span>
                                            </label>
                                            <select
                                                id="countryId"
                                                name="countryId"
                                                value={formPlanData.countryId}
                                                onChange={handleCountryChange}
                                                className={`${inputStyles} appearance-none cursor-pointer`}
                                            >
                                                <option value="">Select Country</option>
                                                {countryData?.map(country => (
                                                    <option key={country.countryid} value={country.countryid}>
                                                        {country.countryname}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.countryId && (
                                                <p className={errorStyles}>{errors.countryId}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="stateId" className={labelStyles}>
                                                State <span className="text-red-400">*</span>
                                            </label>
                                            <select
                                                id="stateId"
                                                name="stateId"
                                                value={formPlanData.stateId}
                                                onChange={handleStateChange}
                                                className={`${inputStyles} appearance-none cursor-pointer ${!formPlanData.countryId ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                disabled={!formPlanData.countryId}
                                            >
                                                <option value="">Select State</option>
                                                {stateData
                                                    .filter(state => state.countryid === Number(formPlanData.countryId))
                                                    .map(state => (
                                                        <option key={state.stateid} value={state.stateid}>
                                                            {state.statename}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors.stateId && (
                                                <p className={errorStyles}>{errors.stateId}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Plan Selection Section */}
                                <div className={sectionStyles}>
                                    <div className={sectionHeaderStyles}>
                                        <FontAwesomeIcon icon={faList} className="w-5 h-5 text-blue-200" />
                                        <h3 className="text-lg font-semibold text-white">Plan Configuration</h3>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div className="space-y-1">
                                            <label htmlFor="planRange" className={labelStyles}>
                                                Plan Range <span className="text-red-400">*</span>
                                            </label>
                                            <select
                                                id="planRange"
                                                name="planRange"
                                                value={formPlanData.planRange}
                                                onChange={handleChange}
                                                className={`${inputStyles} appearance-none cursor-pointer`}
                                            >
                                                <option value="">Select Range</option>
                                                {rangeOptions.map((range) => (
                                                    <option key={range.id} value={range.range}>
                                                        {range.range}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.planRange && (
                                                <p className={errorStyles}>{errors.planRange}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="planPeriod" className={labelStyles}>
                                                <FontAwesomeIcon icon={faCalendar} className="w-3 h-3 mr-2" />
                                                Plan Period <span className="text-red-400">*</span>
                                            </label>
                                            <select
                                                id="planPeriod"
                                                name="planPeriod"
                                                value={formPlanData.planPeriod}
                                                onChange={handleChange}
                                                className={`${inputStyles} appearance-none cursor-pointer`}
                                            >
                                                <option value="">Select Plan Period</option>
                                                {planPeriods.map((period) => (
                                                    <option key={period.id} value={period.period}>
                                                        {period.period}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.planPeriod && (
                                                <p className={errorStyles}>{errors.planPeriod}</p>
                                            )}
                                        </div>

                                        <div className="space-y-1">
                                            <label htmlFor="planType" className={labelStyles}>
                                                Plan Type <span className="text-red-400">*</span>
                                            </label>
                                            <select
                                                id="planType"
                                                name="planType"
                                                value={formPlanData.planType}
                                                onChange={handleChange}
                                                className={`${inputStyles} appearance-none cursor-pointer`}
                                            >
                                                <option value="">Select Plan Type</option>
                                                {planTypes.map((type) => (
                                                    <option key={type.id} value={type.type}>
                                                        {type.type}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.planType && (
                                                <p className={errorStyles}>{errors.planType}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Security & Terms Section */}
                                <div className={sectionStyles}>
                                    <div className={sectionHeaderStyles}>
                                        <FontAwesomeIcon icon={faShieldAlt} className="w-5 h-5 text-blue-200" />
                                        <h3 className="text-lg font-semibold text-white">Security & Agreement</h3>
                                    </div>

                                    {/* First Row - Agreement */}
                                    <div className="mb-6">
                                        <div className="space-y-1">
                                            <label className={labelStyles}>
                                                Agreement <span className="text-red-400">*</span>
                                            </label>
                                            <div className="bg-white/5 border border-white/10 rounded-lg p-4">
                                                <div className="flex items-start gap-3 w-full">
                                                    <div className="flex items-center h-5 mt-0.5">
                                                        <input
                                                            type="checkbox"
                                                            id="acceptTerms"
                                                            checked={acceptTerms}
                                                            onChange={handleCheckboxChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                    </div>
                                                    <label htmlFor="acceptTerms" className="text-sm text-blue-100 leading-relaxed cursor-pointer flex-1">
                                                        I agree to the{' '}
                                                        <Link
                                                            to="#"
                                                            onClick={toggleModal}
                                                            className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
                                                        >
                                                            Terms & Conditions
                                                        </Link>
                                                        {' '}and Privacy Policy
                                                    </label>
                                                </div>
                                            </div>
                                            {errors.acceptTerms && (
                                                <p className={errorStyles}>{errors.acceptTerms}</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Second Row - Three Tiles */}
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        {/* Tile 1: Captcha + Regenerate Button */}
                                        <div className="space-y-1">
                                            <label className={labelStyles}>
                                                Security Verification <span className="text-red-400">*</span>
                                            </label>
                                            <div className="bg-white/5 border border-white/10 rounded-lg p-4 h-24 flex items-center justify-center">
                                                <div className="flex items-center gap-2 flex-row w-full">
                                                    <div className="bg-white rounded-lg p-2 shadow-lg border border-gray-200 flex gap-2 flex-1">
                                                        <canvas
                                                            ref={canvasRef}
                                                            className="rounded w-full"
                                                            style={{ display: 'block', width: '120px', height: 'auto', aspectRatio: '4/1' }}
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={refreshCaptcha}
                                                            className="flex-shrink-0 h-8 w-8 bg-[#1e3c98] hover:bg-blue-700 rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40 group flex items-center justify-center"
                                                            title="Generate new captcha"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faSync}
                                                                className="w-3 h-3 text-white group-hover:rotate-180 transition-transform duration-300"
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Tile 2: Enter Characters Input */}
                                        <div className="space-y-1">
                                            <label className={labelStyles}>
                                                Enter Characters <span className="text-red-400">*</span>
                                            </label>
                                            <div className="bg-white/5 border border-white/10 rounded-lg p-4 h-24 flex items-center">
                                                <input
                                                    type="text"
                                                    value={userInput}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter the characters shown"
                                                    className={`${inputStyles} text-center font-mono tracking-wider `}
                                                    maxLength={6}
                                                />
                                            </div>
                                            {errors.captcha && (
                                                <p className={errorStyles}>{errors.captcha}</p>
                                            )}
                                        </div>

                                        {/* Tile 3: Action Buttons (Icons Only) */}
                                        <div className="space-y-1">
                                            <label className={labelStyles}>
                                                Actions <span className="text-red-400">*</span>
                                            </label>
                                            <div className="bg-white/5 border border-white/10 rounded-lg p-4 h-24 flex items-center justify-center">
                                                <div className="flex gap-3">
                                                    <button
                                                        type="button"
                                                        onClick={resetForm}
                                                        className="flex-1 h-12 px-6 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40 hover:scale-105 transform text-sm flex items-center justify-center"
                                                    >
                                                        <FontAwesomeIcon icon={faSync} className="w-4 h-4 mr-2" />
                                                        Reset Form
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="flex-1 h-12 px-6 bg-white hover:bg-gray-100 text-blue-800 font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform text-sm flex items-center justify-center"
                                                    >
                                                        <FontAwesomeIcon icon={faClipboardList} className="w-4 h-4 mr-2" />
                                                        Complete Registration
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Form Actions Section */}
                                {/* <div className="bg-white/5 rounded-xl p-5 backdrop-blur-sm border border-white/10">
                                    <div className="flex items-center justify-center">
                                        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md">
                                            <button
                                                type="button"
                                                onClick={resetForm}
                                                className="flex-1 h-12 px-6 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40 hover:scale-105 transform text-sm flex items-center justify-center"
                                            >
                                                <FontAwesomeIcon icon={faSync} className="w-4 h-4 mr-2" />
                                                Reset Form
                                            </button>
                                            <button
                                                type="submit"
                                                className="flex-1 h-12 px-6 bg-white hover:bg-gray-100 text-blue-800 font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform text-sm flex items-center justify-center"
                                            >
                                                <FontAwesomeIcon icon={faClipboardList} className="w-4 h-4 mr-2" />
                                                Complete Registration
                                            </button>
                                        </div>
                                    </div>
                                </div> */}
                            </form>
                        </div>

                        {/* Enhanced Modal for Terms */}
                        {showModal && (
                            <div className="fixed z-[10000] inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
                                <div className="relative bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
                                    <div className="flex items-center justify-between p-5 border-b border-white/10">
                                        <h3 className="text-xl font-bold text-white">Terms & Conditions</h3>
                                        <button
                                            onClick={toggleModal}
                                            className="p-2 hover:bg-white/10 rounded-lg transition-colors duration-200"
                                        >
                                            <span className="text-2xl text-white hover:text-gray-300">&times;</span>
                                        </button>
                                    </div>
                                    <div className="p-5 overflow-y-auto max-h-[calc(90vh-80px)]">
                                        <HoaTermsConditions closeModal={toggleModal} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default HoaChoosePlan;